var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMarkerLightRed = function SvgMarkerLightRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "-4 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0c7.732 0 14 5.641 14 12.6C28 23.963 14 36 14 36S0 24.064 0 12.6C0 5.641 6.268 0 14 0Z",
    fill: "#ff4122"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    fillRule: "nonzero",
    cx: 14,
    cy: 14,
    r: 7
  }))));
};
export { SvgMarkerLightRed as ReactComponent };
export default __webpack_public_path__ + "images/marker-light-red.svg";